import { useState, useEffect } from "react"

function getUserAgent() {
  let userAgent = "x"
  if (typeof window !== "undefined") {
    return (userAgent = window.navigator.userAgent)
  }
  return userAgent
}

const useWebviewChecker = () => {
  const mobileAppCustomUserAgent = "ShopSMMobileApp"
  const [isWebview, setIsWebview] = useState(true)
  const userAgent = getUserAgent()

  useEffect(() => {
    setIsWebview(userAgent.includes(mobileAppCustomUserAgent))
  }, [userAgent])

  return isWebview
}

export default useWebviewChecker
